import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 共済契約申請書参照API
// API仕様書_契約者
import {
  IAPI_CON002_Request,
  IAPI_CON002_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 共済契約申請書参照API
// API仕様書_契約者
const httpIAPI_CON002 = async (
  param: IAPI_CON002_Request
): Promise<IAPI_CON002_Response> => {
  let res = await http.post(ApiUrl.API_CON002, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON002, httpIAPI_APP016 };
